import React from "react";

const FeatureCard = ({ title, desc, icon }) => (
  <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300 group">
    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-500 transition-colors">
      <svg
        className="w-6 h-6 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        {icon}
      </svg>
    </div>
    <h3 className="text-xl font-bold mb-3 text-white">{title}</h3>
    <p className="text-white leading-relaxed text-sm">{desc}</p>
  </div>
);

const EnterpriseSection = () => {
  return (
    <section className="py-24 bg-blue-900 text-white relative overflow-hidden">
      {/* PATTERN BACKGROUND */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "radial-gradient(circle, #ffffff 1px, transparent 1px)",
          backgroundSize: "30px 30px",
        }}
      ></div>

      <div className="container mx-auto px-6 max-w-screen-xl relative z-10">
        <div className="text-center mb-20">
          <span className="text-blue-400 font-bold tracking-wider uppercase text-sm">
            Enterprise Architecture
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-6">
            Complex Data for <br />
            <span className="text-blue-400">Heavy Industries</span>
          </h2>
          <p className="text-lg text-emerald-100/80 max-w-3xl mx-auto">
            For sectors where data integrity equals money and safety, we build
            fortified databases handling millions of transactions securely.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* CARD 1 MONEY EXCHANGE*/}
          <FeatureCard
            title="Money Exchange"
            desc="High-frequency transaction processing with multi-currency ledger support and strict security protocols."
            icon={
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            }
          />

          {/* CARD 2 */}
          <FeatureCard
            title="Manufacturing"
            desc="Production line monitoring, raw material tracking, and supply chain automation databases."
            icon={
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
              />
            }
          />

          {/* CARD 3 LAB*/}
          <FeatureCard
            title="Laboratories"
            desc="Secure patient data storage, test result archiving, and compliance with medical standards."
            icon={
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
              />
            }
          />

          {/* CARD 4 LOGISTICS*/}
          <FeatureCard
            title="Logistics"
            desc="Real-time fleet tracking, route optimization, and delivery management systems."
            icon={
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            }
          />

          {/* CARD 5 INSURANCE */}
          <FeatureCard
            title="Insurance"
            desc="Policy management, claim processing workflows, and customer risk profiling."
            icon={
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            }
          />

          {/* CARD 6 BANKING */}
          <FeatureCard
            title="Banking Systems"
            desc="Core banking modules, loan management, and high-security transaction logs."
            icon={
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
              />
            }
          />
        </div>
      </div>
    </section>
  );
};

export default EnterpriseSection;
